








export default
  props:
    midashi:
      type: String
    title:
      type: String
    message:
      type: Array
      default: []
